/**
 * RendiFinderUrl.build — pure, isolated URL builder for the finder (ENG-266,
 * docs/adr/0001-finder-globo-deeplink.md). No DOM access: given the base
 * collection URL, the dimension→Search-API-param map (from
 * finder-globo-map.liquid) and the current selections, it returns the
 * collection URL with <param>=<value> pairs. Multi-value = repeated key (OR
 * within a dimension), the same contract <rendi-search-listing> reads.
 */
window.RendiFinderUrl = window.RendiFinderUrl || (function () {
  function build(baseUrl, params, selections) {
    var query = new URLSearchParams();

    Object.keys(params).forEach(function (dimension) {
      var name = params[dimension];
      var values = selections[dimension] || [];
      values.forEach(function (value) {
        if (value) query.append(name, value);
      });
    });

    var encoded = query.toString();
    return encoded ? baseUrl + '?' + encoded : baseUrl;
  }

  return { build: build };
})();
